import React, {useState} from 'react';
import styled from 'styled-components'

export function CourseVideoFiles({files, hasAccess, courseId}) {
    return (
        <Container>
            <Title>Archivos descargables</Title>
            {!hasAccess && (<ErrorMessage>No tienes acceso a los recursos, debes suscribirte para acceder</ErrorMessage>)}
            <ListContainer>
                <List>
                    {files.map(file => {
                        return (<Item key={`file_download_${file.id}`}>

                            <Image src='/images/icons/pdf.png' />
                            {!hasAccess && (<Image src='/images/icons/lock.png' />)}
                            {hasAccess
                                ? (<Link target='_blank' href={`/downl/${file.id}`}>{file.name}</Link>)
                                : (<Link href='#'>{file.name}</Link>)}

                        </Item>)
                    })}
                </List>
            </ListContainer>
        </Container>
    )
}

const Container = styled.div`
    padding-top: 36px;
`

const ErrorMessage = styled.div`
    color: red;
    text-align: center;
    padding-top: 12px;
    padding-bottom: 12px;
`
const Image = styled.img`
    width: 16px;
    margin-right: 4px;
`

const Title = styled.div`
    text-align: center;
    font-size: 22px;
    color: #FA9F63;
`

const ListContainer = styled.div`
  display: flex;
    flex-direction: row;
    justify-content: center;
`

const Link = styled.a`

`

const List = styled.div`
    max-width: 640px;
    display: flex;
    flex-direction: column;

`

const Item = styled.div`
    padding: 12px;
`
